import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import ArticleInfoRow from '../../../molecules/blogArticle/articleInfoRow/ArticleInfoRow';
import ArticleImageSection from '../articleImageSection/ArticleImageSection';
import ArticleHelperBox from '../../../molecules/blogArticle/articleHelperBox/ArticleHelperBox';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

const Article = ({ data, helperData, t }) => {
  const article = data.content;

  const middle = Math.floor(article.split('</p>').length / 2);

  const articleParts = article.split('</p>');

  const halfBeforeBreak = articleParts.slice(0, middle).join('</p>');
  const halfAfterBreak = articleParts.slice(middle).join('</p>');

  return (
    <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto max-w-6xl">
      <div className="flex flex-col flex-1 justify-between items-center gap-5">
        <div className="flex flex-col gap-2 max-w-3xl w-full">
          <Typography as="h1" fontVariant="h4" textAlign="left">
            {data.title}
          </Typography>
          <ArticleInfoRow item={data} t={t} />
        </div>
        <ArticleImageSection data={{ ...data, isBottomSection: false }} t={t} />
        <div className="flex flex-col max-w-3xl w-full gap-5">
          <StyledHtmlDiv content={halfBeforeBreak?.trim()} />
          {/*
          <Typography
            textAlign={'left'}
            fontVariant={'h7'}
            className={'font-light'}
          >
            <b>TODO Hitta lämpligt ställe i mitten av artikeln och lägg in</b>
            ArticleHelperBox: {data.description}
          </Typography>
          <Typography
            textAlign={'left'}
            fontVariant={'md'}
            className={'font-light'}
          >
            {data.introText}
          </Typography>
          */}
          {helperData?.title && (
            <ArticleHelperBox
              title={helperData?.title}
              /*
            subtitle={
              'TODO Är du i behov av kravställning eller urvalsprocess av leverantörer? BusinessWith erbjuder kompetenta och erfarna system-konsulter.'
              } */
              button1Label={helperData?.button1Label}
              button1Href={helperData?.button1Href}
              button2Label={helperData?.button2Label}
              button2Href={helperData?.button2Href}
            />
          )}
          <StyledHtmlDiv content={halfAfterBreak?.trim()} />
        </div>
        <ArticleImageSection data={{ ...data, isBottomSection: true }} t={t} />
      </div>
    </div>
  );
};

export default Article;
